
export class AppError { 
    constructor(public originalError?: any) {}
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/common/app-error.ts